import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { puede } from "../../../../permisos/permisos";

function VentaDirecta() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  let cancela = moment(date).add(60, "days").format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [empresas, setEmpresas] = useState([]);

  const [fecha, setFecha] = useState(hoy);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [value, setValue] = useState(""); // cliente seleccionado (autocomplete)
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [observaciones, setObservaciones] = useState("NA");

  // Artículo seleccionado y su desglose color x talla
  const [articuloSel, setArticuloSel] = useState(null);
  const [precio, setPrecio] = useState(0);
  const [colores, setColores] = useState([]); // [{_id, name}]
  const [tallas, setTallas] = useState([]); // [{_id, name}]
  const [grid, setGrid] = useState([]); // [{colores, colorNombre, tallas, tallaNombre, cantidad}]

  // Modo de captura por proporción
  const [modalProporcion, setModalProporcion] = useState(false);
  const toggleProporcion = () => setModalProporcion(!modalProporcion);
  const [colorProporcion, setColorProporcion] = useState(""); // color al que se aplica
  const [totalProporcion, setTotalProporcion] = useState(0);
  const [proporciones, setProporciones] = useState([]); // [{tallas, tallaNombre, proporcion}]

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios.get(URL_ARTICULOS, { headers }).then((res) => setArticulos(res.data)).catch(console.log);
    axios.get(URL_CLIENTES, { headers }).then((res) => setClientes(res.data)).catch(console.log);
    axios.get(URL_COLABORADORES, { headers }).then((res) => setColaboradores(res.data)).catch(console.log);
    axios.get(URL_EMPRESAS, { headers }).then((res) => setEmpresas(res.data)).catch(console.log);
  }, []); // eslint-disable-line

  // Al elegir un artículo, despliega sus colores y tallas en una rejilla
  function seleccionaArticulo(art) {
    setArticuloSel(art);
    if (!art) {
      setColores([]);
      setTallas([]);
      setGrid([]);
      return;
    }
    setPrecio(art.venta || 0);
    let cols = art.colores || [];
    let tals = art.tallas || [];
    setColores(cols);
    setTallas(tals);

    const nuevo = [];
    if (tals.length > 0) {
      cols.forEach((c) => {
        tals.forEach((t) => {
          nuevo.push({
            colores: c._id,
            colorNombre: c.name,
            tallas: t._id,
            tallaNombre: t.name,
            cantidad: 0,
          });
        });
      });
    } else if (cols.length > 0) {
      // Plásticos: solo colores, sin tallas.
      cols.forEach((c) => {
        nuevo.push({
          colores: c._id,
          colorNombre: c.name,
          tallas: "",
          tallaNombre: "",
          cantidad: 0,
        });
      });
    } else {
      // Sin colores ni tallas: una sola partida.
      nuevo.push({ colores: "", colorNombre: "", tallas: "", tallaNombre: "", cantidad: 0 });
    }
    setGrid(nuevo);
  }

  // Edición directa de cantidad por talla
  function cambiaCantidad(idColor, idTalla, valor) {
    setGrid((prev) =>
      prev.map((g) =>
        g.colores === idColor && g.tallas === idTalla
          ? { ...g, cantidad: valor }
          : g
      )
    );
  }

  // Abre el modal de proporción para un color
  function abreProporcion(idColor) {
    setColorProporcion(idColor);
    setTotalProporcion(0);
    setProporciones(
      tallas.map((t) => ({ tallas: t._id, tallaNombre: t.name, proporcion: 0 }))
    );
    toggleProporcion();
  }

  function cambiaProporcion(idTalla, valor) {
    setProporciones((prev) =>
      prev.map((p) =>
        p.tallas === idTalla ? { ...p, proporcion: valor } : p
      )
    );
  }

  // Aplica: cantidad por talla = total * proporcion / sumaProporciones
  function aplicaProporcion() {
    let suma = proporciones.reduce(
      (t, p) => t + (parseFloat(p.proporcion) || 0),
      0
    );
    if (suma <= 0 || totalProporcion <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Captura el total y al menos una proporción.",
      });
      return;
    }
    setGrid((prev) =>
      prev.map((g) => {
        if (g.colores !== colorProporcion) return g;
        let prop = proporciones.find((p) => p.tallas === g.tallas);
        let p = prop ? parseFloat(prop.proporcion) || 0 : 0;
        let cant = Math.round((totalProporcion * p) / suma);
        return { ...g, cantidad: cant };
      })
    );
    toggleProporcion();
  }

  const totalPiezas = grid.reduce(
    (t, g) => t + (parseFloat(g.cantidad) || 0),
    0
  );
  const totalGeneral = totalPiezas * (parseFloat(precio) || 0);

  const saveVenta = async (event) => {
    event.preventDefault();
    if (!value || !value._id) {
      Swal.fire({ icon: "warning", title: "Falta el cliente" });
      return;
    }
    if (!articuloSel || totalPiezas <= 0) {
      Swal.fire({ icon: "warning", title: "Captura cantidades" });
      return;
    }
    setValidaBoton(false);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    try {
      const dataPedido = await axios.post(
        URL_PEDIDOS,
        {
          fecha,
          fechaEstado: fecha,
          fechaCreacion: hoy,
          resurtido: "Si",
          ventaDirecta: "Si",
          empresas: selectedEmpresa,
          clientes: value._id,
          colaboradores: selectedColaborador || "613a9434225bce3df050c220",
          fecha_cancelacion: cancela,
          fecha_confirmacion: hoy,
          total_general: totalGeneral,
          total_piezas: totalPiezas,
          observaciones: observaciones || "NA",
          articulos: articuloSel._id,
          pedidoCliente: "NA",
          compradores: "613a9434225bce3df050c220",
          surtido: 0,
          pendiente_surtir: totalPiezas,
          confirmacionPedido: "No",
          status: "Abierto",
          fechaEstCodigos: hoy,
          fechaEstFicha: hoy,
          fechaEstAuditoria: hoy,
          fechaEstMuestraFit: hoy,
          fechaEstMuestraConfirmacion: hoy,
          fechaEstEtiquetas: hoy,
          fechaRealCodigos: hoy,
          fechaRealFicha: hoy,
          fechaRealAuditoria: hoy,
          fechaRealMuestraFit: hoy,
          fechaRealMuestraConfirmacion: hoy,
          fechaRealEtiquetas: hoy,
          autorizacionFitFecha: hoy,
          autorizacionCostosFecha: hoy,
          autorizacionDisenoFecha: hoy,
          autorizacionCalidadFecha: hoy,
          autorizacionPloterFecha: hoy,
          autorizacionPloterDisenoFecha: hoy,
          autorizacionSurtirFecha: hoy,
          autorizacionFitColaborador: "613a9434225bce3df050c220",
          autorizacionCostosColaborador: "613a9434225bce3df050c220",
          autorizacionDisenoColaborador: "613a9434225bce3df050c220",
          autorizacionCalidadColaborador: "613a9434225bce3df050c220",
          autorizacionPloterColaborador: "613a9434225bce3df050c220",
          autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
          autorizacionSurtirColaborador: "613a9434225bce3df050c220",
          descuento: 0,
        },
        { headers }
      );

      const idPedido = dataPedido.data._id;

      // Una línea de ArticulosPedido por cada talla con cantidad > 0
      for (const g of grid) {
        if (parseFloat(g.cantidad) > 0) {
          await axios.post(
            URL_ARTICULOS_PEDIDO,
            {
              pedidos: idPedido,
              articulos: articuloSel._id,
              ...(g.colores ? { colores: g.colores } : {}),
              ...(g.tallas ? { tallas: g.tallas } : {}),
              cantidad: parseFloat(g.cantidad),
              pendienteCortar: parseFloat(g.cantidad),
              cortado: 0,
              surtido: 0,
              pendiente_surtir: parseFloat(g.cantidad),
              cantidad_procesos: parseFloat(g.cantidad),
              precio: parseFloat(precio),
              descuento: 0,
              total: (parseFloat(g.cantidad) * parseFloat(precio)).toFixed(2),
              codigoBarras: 0,
              precioEtiqueta: 0,
              resurtido: "Si",
              codigoCliente: "NA",
            },
            { headers }
          );
        }
      }

      // Actualiza fecha de último pedido en el cliente (Ticket 3)
      await axios.patch(`${URL_CLIENTES}/${value._id}`, { ultimoPedido: fecha }, { headers });

      axios.post(
        URL_LOGS,
        { tipo: "Venta Directa", detalle: `${articuloSel.codigo}`, user: user.id },
        { headers }
      );

      Swal.fire("Listo", "Venta directa registrada con éxito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1200);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response ? error.response.data : ""}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

  // Opciones para el autocomplete de cliente
  const options = clientes.map((c) => {
    const firstLetter = (c.nombre_comercial || "#")[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...c,
      junta: `${c.nombre_comercial}`,
    };
  });

  return (
    <>
      <Header />
      <br />
      {puede(user, "ventas.ventaDirecta.ver") ? (
        <div className="card container col-12">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-cash-register" style={{ marginRight: 8, color: "#10b981" }} />
                Venta Directa
              </h3>
              <p className="page-subtitle">
                Selecciona artículo y color, captura por proporción o cantidad por talla
              </p>
            </div>
          </div>

          <Form onSubmit={saveVenta}>
            {/* Datos generales */}
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-info-circle" />
                <span className="form-section-title">Datos Generales</span>
              </div>
              <div className="form-section-body">
                <Row>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fecha}
                      required
                      onChange={(e) => setFecha(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Cliente</Label>
                    <Autocomplete
                      size="small"
                      value={value}
                      onChange={(event, sel) => setValue(sel)}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta || ""}
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Empresa</Label>
                    <Input
                      type="select"
                      value={selectedEmpresa}
                      required
                      onChange={(e) => setSelectedEmpresa(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {empresas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => (
                          <option key={a._id} value={a._id}>
                            {a.name}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaborador}
                      onChange={(e) => setSelectedColaborador(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => (
                          <option key={a._id} value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      value={observaciones}
                      onChange={(e) => setObservaciones(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Label>Artículo</Label>
                    <Autocomplete
                      size="small"
                      value={articuloSel}
                      onChange={(event, sel) => seleccionaArticulo(sel)}
                      options={articulos.sort((a, b) =>
                        (a.codigo || "") > (b.codigo || "") ? 1 : -1
                      )}
                      getOptionLabel={(option) =>
                        option ? `${option.codigo} ${option.descripcion || ""}` : ""
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Selecciona artículo" variant="outlined" />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Precio</Label>
                    <Input type="number" value={precio} disabled />
                  </Col>
                </Row>
              </div>
            </div>

            {/* Captura por color y talla */}
            {articuloSel && (
              <div className="form-section">
                <div className="form-section-header">
                  <i className="fas fa-table" />
                  <span className="form-section-title">
                    {tallas.length > 0 ? "Captura por Color y Talla" : "Captura por Color"}
                  </span>
                </div>
                <div className="form-section-body">
                  {tallas.length > 0 ? (
                    colores.map((col) => (
                      <div key={col._id} style={{ marginBottom: 14 }}>
                        <Row className="align-items-end">
                          <Col md={2}>
                            <strong>{col.name}</strong>
                            <br />
                            <Button
                              size="sm"
                              color="primary"
                              type="button"
                              style={{ marginTop: 4 }}
                              onClick={() => abreProporcion(col._id)}
                            >
                              <i className="fas fa-percentage" style={{ marginRight: 4 }} />
                              Proporción
                            </Button>
                          </Col>
                          {grid
                            .filter((g) => g.colores === col._id)
                            .map((g) => (
                              <Col md={1} key={g.tallas}>
                                <Label>{g.tallaNombre}</Label>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  value={g.cantidad}
                                  onChange={(e) =>
                                    cambiaCantidad(g.colores, g.tallas, e.target.value)
                                  }
                                />
                              </Col>
                            ))}
                        </Row>
                      </div>
                    ))
                  ) : (
                    // Plásticos: captura de piezas por color (o partida única si no hay colores).
                    <Row className="align-items-end">
                      {grid.map((g) => (
                        <Col md={2} key={g.colores || "unico"} style={{ marginBottom: 10 }}>
                          <Label><strong>{g.colorNombre || "Piezas"}</strong></Label>
                          <Input
                            bsSize="sm"
                            type="number"
                            min="0"
                            value={g.cantidad}
                            onChange={(e) =>
                              cambiaCantidad(g.colores, g.tallas, e.target.value)
                            }
                          />
                        </Col>
                      ))}
                    </Row>
                  )}
                  <Row>
                    <Col md={12}>
                      <h4 style={{ marginTop: 10 }}>
                        TOTALES {totalPiezas} pzas. /{" "}
                        {"$" + new Intl.NumberFormat("en-US").format(totalGeneral)}
                      </h4>
                    </Col>
                  </Row>
                </div>
              </div>
            )}

            <div className="submit-bar">
              <Button href="/MenuVentas" className="btn btn-danger" id="botonListado">
                Regresar
              </Button>
              <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar Venta
              </Button>
            </div>
          </Form>

          {/* Modal de captura por proporción */}
          <Modal isOpen={modalProporcion} toggle={toggleProporcion}>
            <ModalHeader toggle={toggleProporcion}>
              <i className="fas fa-percentage" style={{ marginRight: 8, color: "#3b82f6" }} />
              Captura por proporción
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={6}>
                  <Label>Total a repartir</Label>
                  <Input
                    type="number"
                    min="0"
                    value={totalProporcion}
                    onChange={(e) => setTotalProporcion(parseFloat(e.target.value) || 0)}
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                {proporciones.map((p) => (
                  <Col md={3} key={p.tallas} style={{ marginBottom: 8 }}>
                    <Label>{p.tallaNombre}</Label>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      value={p.proporcion}
                      onChange={(e) => cambiaProporcion(p.tallas, e.target.value)}
                    />
                  </Col>
                ))}
              </Row>
              <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: 8 }}>
                La cantidad de cada talla = Total × (proporción de la talla ÷ suma de
                proporciones).
              </p>
              <div className="submit-bar">
                <Button color="secondary" type="button" onClick={toggleProporcion}>
                  Cancelar
                </Button>
                <Button color="success" type="button" onClick={aplicaProporcion}>
                  Aplicar
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentaDirecta;
